/*
 * T2 (Titipan auditor 26 Okt 2026) — nomor HP customer disimpan BAKU "62…" (backend `services/nomor_hp.py`),
 * tampil ke staf "08…". Cermin `nomor_hp.tampil`: yang tidak terbaca ditampilkan apa adanya.
 */
export function tampilHp(nomor) {
  if (!nomor) return "";
  let d = String(nomor).replace(/\D/g, "");
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  if (!/^62\d{8,13}$/.test(d)) return String(nomor).trim();
  return "0" + d.slice(2);
}
